interface IrequestHelper {
  setLoading?: (value: boolean) => void;
  action: any;
  onSuccess?: (response: any) => void;
  onError?: (error: any) => void;
}

export async function requestHelper({
  setLoading,
  action,
  onSuccess,
  onError,
}: IrequestHelper) {
  try {
    setLoading?.(true);
    const response = await action?.();

    onSuccess?.(response);
  } catch (error) {
    onError?.(error);
  } finally {
    setLoading?.(false);
  }
}
